import { useMutation } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { MapIntegrationPlan } from "@modules/mapIntegrationPlans/types";
import { MapIntegrationPlanFormValues } from "@modules/mapIntegrationPlans/validations";
import { editMapIntegrationPlanService } from "./service";
import { UseEditMapIntegrationPlanMutationOptions } from "./types";

export function useEditMapIntegrationPlanMutation(
  options?: UseEditMapIntegrationPlanMutationOptions
) {
  const { open } = useNotification();
  const translate = useTranslate();

  return useMutation<MapIntegrationPlan, ApiError, { id: string; data: MapIntegrationPlanFormValues }>({
    mutationFn: ({ id, data }) => editMapIntegrationPlanService(id, data),
    onSuccess: () => {
      open?.({
        type: "success",
        message: translate("subscription_mapintegrationplan_admin.success.edit"),
      });
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
